/* eslint-disable */

// Setup facets to be used in drawers for collection page.
(function(algolia) {
    'use strict';

    var rangeSlider = algolia.externals.widgets.rangeSlider;
    var menu = algolia.externals.widgets.menu;
    var refinementList = algolia.externals.widgets.refinementList;
  
    // Defines widgets for easy access.
    // For example, if you want to use a refinementList widget
    // with the disjunctive type, operator 'or' and a limit of 100
    // just pass the "disjunctive" key
    var TYPES_TO_WIDGET = {
      slider: { name: 'rangeSlider', useDefault: true, widget: rangeSlider },
      menu: { name: 'menu', params: { limit: 100 }, widget: menu },
      conjunctive: {
        name: 'refinementList',
        params: { operator: 'and', limit: 100 },
        widget: refinementList,
      },
      disjunctive: {
        name: 'refinementList',
        params: { operator: 'or', limit: 100 },
        widget: refinementList,
      },
    };
  
    var sortByRefined = function sortByRefined(sortFunction) {
      return function(a, b) {
        if (a.refined !== b.refined) {
          if (a.refined) {
            return -1;
          }
          if (b.refined) {
            return 1;
          }
        }
        return sortFunction(a, b);
      };
    };
  
    /*
     * Sorting functions : Allows to chose in which order you want to display the facets
     * Algolia will always send you back the most relevant values for each facet (the ones
     * with the highest count). These sorting functions won't change which results come back
     * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
     * parameter in your Algolia Dashboard.
     * The default sort function is refined > count > name.
     */
    algolia.facetSortFunctions = {
      price_range: sortByRefined(function sortRanges(a, b) {
        if (a.name.length === b.name.length) {
          return a.name.localeCompare(b.name);
        }
        return a.name.length - b.name.length;
      }),
    };
  
    /*
     * Display functions
     * When the object sent back for a facet item doesn't match how you would want it to look
     * like, use a function to reformat it how you want.
     */
    algolia.facetDisplayFunctions = {
      price_range: function displayRange(value) {
        var values = value.split(':');
  
        return values
          .map(e => {
            return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
          })
          .join(' - ');
      },
      price: function displayPrice(value){
        return value
          .map(price=>{
            return `${algolia.formatPrice(price)}`
          })
      },
    };
  
    // Most classes are for the widgets ex RefinementList
    algolia.facetCssClasses = {
      root: 'ais-facet',
      header: 'ais-facet--header',
      body: 'ais-facet--body',
      item: 'ais-facet--item',
      label: 'ais-facet--label',
      checkbox: 'ais-facet--checkbox',
      active: 'ais-facet--active',
      count: Boolean(algolia.config.show_products) ? 'ais-facet--count-distinct' : 'ais-facet--count',
    };

    //creates a list of facets( enabled and disabled) from config file
    // InstantSearch facets for filters:
    // algolia.config.facets = shop.metafields.algolia_search.instantsearch_facets
    var enabledFacets = algolia.config.facets.filter(facet => {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    // Modify enabledFacets to add one field, escapedName
    algolia.facets = enabledFacets.map(facet => ({
      ...facet,
      escapedName: encodeURIComponent(facet.name),
    }));
    
    // Return facets that are NOT hidden
    algolia.shownFacets = algolia.facets.filter(facet => {
      return facet.type !== 'hidden';
    });

    // Return facets that are hidden
    algolia.hiddenFacets = algolia.config.facets.filter(facet => {
      return facet.type === 'hidden';
    });

    //similar format from algolia doc https://www.algolia.com/doc/api-reference/widgets/range-slider/js/
    /* 
      Description: Creates widget configuration object
      @param {object} facet - The facet object from the config file
      @return {object} - The widget object with name, params and widget
      @example
      {
        name: 'refinementList',
        params: {
          container: '[class~="ais-facet-collection-container"]',
          attribute: 'collection',
          templates: {
            header: function() {
              return 'Collection';
            },
          },
        },
        widget: refinementList,
      }
      @example
      {
        name: 'rangeSlider',
        params: {
          container: '[class~="ais-facet-price-range-container"]',
          attribute: 'price_range',
          tooltips: {
            format(value) {
              return `${algolia.formatPrice(value)}`;
            },
          },
        },
        widget: rangeSlider,
      }
    */
    var facetToWidget = function(facet) {
      // Get the widget config based on the facet object type
      var widget = TYPES_TO_WIDGET[facet.type];
      // Grab the widget params
      var params = algolia.assign({}, widget.params);
      // Add more attributes/fields to your params object
      params.container =
        "[class~='ais-facet-" + facet.escapedName + "-container']";
      params.attribute = facet.name;
      params.templates = {};
      params.cssClasses = algolia.facetCssClasses;
  
      /**
       * Providing a custom "Show more" template to confirm to the custom
       */
      params.templates.showMoreText = function showMoreText(data, {html}) {
        return algolia.instantSearchShowMore(data, html)
      }
  
      // Our widgets are not searchable so this should not execute.
      if (facet.searchable) {
        params.searchable = true;
        params.searchablePlaceholder = 'Search for ' + facet.title;
        params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
      }
  
      // Add title to template header 
      // in our Algolia 1.0 this is what shows the dropdown title
      params.templates.header = function() {
        return facet.title;
      };
  
      // If this is not a slider widget execute
      if (!widget.useDefault) {
        params.templates.item = (item, {html}) => {
          return algolia.instantSearchFacetItem(item, html)
        }
      }

      // facetSortFunctions only contains price-range function
      if (algolia.facetSortFunctions[facet.name]) {
        params.sortBy = algolia.facetSortFunctions[facet.name];
      }

      if(facet.type === 'slider'){//add any slider parameters here
        params.precision = -1; //rounds slider values to nearest tenth
        params.tooltips = {
          format(value){
            return `${algolia.formatPrice(value)}`
          }
        } 
      }
  
      let displayFunction = algolia.facetDisplayFunctions[facet.name];

      // This contains an array of facet items
      // ex [{count: 133, isRefined: false, value: 'Decorative Accessories'}...]
      params.transformItems = function(items) {
        return items.map(item => ({
          ...item,
          type: facet.type,
          label: displayFunction ? displayFunction(item.value) : item.value
        }));
      }

      return {
        name: widget.name,
        params: params,
        widget: widget.widget,
      };
    };
  
    // fetch all disabled and enabled facets for current collection or fallback to collections default
    /** src/snippets/algolia_config.liquid sets the collection information based on
     * on the current collection id.
     * If current collection id and collection facets and the specific collection id facets
     * all exist then set collection_facets to specific collection id facets else to a default
    */
    var collection_facets =
      algolia.current_collection_id &&
      algolia.config.collection_facets &&
      algolia.config.collection_facets[algolia.current_collection_id]
        ? algolia.config.collection_facets[algolia.current_collection_id]
        : algolia.config.collection_facets &&
          algolia.config.collection_facets.default;
  
    if (collection_facets) {
      // Return enabled facets from collection_facets
      var enabledCollectionFacets = collection_facets.filter(facet => {
        return facet.enabled || parseInt(facet.enabled, 10);
      });
  
      // Encode facet name and add it
      algolia.collectionFacets = enabledCollectionFacets.map(facet => ({
        ...facet,
        escapedName: encodeURIComponent(facet.name)
      }));

      // Return collectionFacets that are not hidden
      algolia.collectionShownFacets = algolia.collectionFacets.filter(facet => {
        return facet.type !== 'hidden';
      });

      // Hidden facets
      algolia.collectionHiddenFacets = collection_facets.filter(facet => {
        return facet.type === 'hidden';
      });

      // These widgets will be used in algolia_instant_search.js.liquid
      algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(facetToWidget);
    }
    
    algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
  })(window.algoliaShopify);
  